import { useState, useEffect } from "react";
import {
  Avatar,
  Button,
  Card,
  Row,
  Col,
  Form,
  Input,
  Radio,
  Select,
  DatePicker,
  Alert,
} from "antd";
import { Link } from "react-router-dom";
import moment from 'moment'
import dayjs from 'dayjs';
import {
  AddressControl,
  ContactField,
  contribEnum,
  localityEnum,
  Messages,
  Notify,
  openNotification,
  util,
} from '@seims/shared';

import { GlobalOutlined } from "@ant-design/icons";
import RepresentativeList from "../representatives/RepresentativeList";
import lookupAPI from "../../services/partnershipLookupService";
import api from "../../services/partnershipService";
import { recordError } from "../../utils/logService";

const CreatePartner = () => {
  const [types, setTypes] = useState([]);
  const [contributions, setContributions] = useState([]);
  const [localityOptions, setLocalityOption] = useState([]);
  const [selectedOption, setSelectedOption] = useState("");
  const [address, setAddress] = useState();
  const [partnerSummary, setpartnerSummary] = useState({
    name: "",
    contact: "",
  });
  const [isLocal, setIsLocal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showAddressInfo, setshowAddressInfo] = useState(false);
  const [showOther, setShowOther] = useState(false);
  const [representatives, setRepresentatives] = useState([]);
  const [defaultContact, setDefaultContact] = useState("+27");

  const dateFormat = "YYYY-MM";

  const formItemLayout = {
    labelCol: {
      span: 8,
    },
    wrapperCol: {
      span: 16,
    },
  };

  const { Option } = Select;
  const { Meta } = Card;
  const [form] = Form.useForm();
  const formName = "PartnerForm";

  useEffect(() => {
    getPartnerTypes();
    getLocalityTypes();
    getContributions();
  }, []);

  const getPartnerTypes = async () => {
    try {
      const response = await lookupAPI.getPartnerTypes();
      if (response) {
        const { data } = response;
        setTypes(data);
      }
    } catch (error) {
      recordError(error);
    }
  };

  const getLocalityTypes = async () => {
    try {
      const response = await lookupAPI.getLocalityTypes();
      if (response) {
        const { data } = response;
        setLocalityOption(data.sort(util.setDynamicSort("key")));
      }
    } catch (error) {
      recordError(error);
    }
  };

  const getContributions = async () => {
    try {
      const module = 'partnership';
      const response = await lookupAPI.getContributions(module);
      if (response) {
        const { data } = response;
        setContributions(data);
      }
    } catch (error) {
      recordError(error);
    }
  };

  const onChange = (selected) => {
    const selectedType = types.find((record) => record.value === selected);
    form.setFieldsValue({ partnerType: selectedType });
  };

  const onInitiationChange = (selectedDate) => {
    
  }

  const disabledDates = (current) => {
    return current && current > dayjs().endOf('day');
  }

  const onChangeLocality = (e) => {

    const { value: selected } = e.target;
    const selectedLocality = localityOptions.find((record) => record.key === selected);

    if (selectedLocality.value == localityEnum.LOCAL) {
      setIsLocal(true);
    } else {
      setIsLocal(false);
    }

    setSelectedOption(selected);
    setShowModal(true);
  };

  const handleCancel = () => {
    setShowModal(false);
  };

  const handleContactChange = (value) => {


    // if (value === 0 || value.length < 10) {
    //   form.setFieldsValue({ contact: undefined });
    //   form.setFieldsValue({ contact: util.toNumeric(value) });
    //   return;
    // }
    // // form.setFieldsValue({ contact: value });
    // let partner = { ...partnerSummary };
    // partner.contact = value;
    // setpartnerSummary(partner);

    if (value === 0 || value.length < 10) {
      form.setFieldsValue({ contact: undefined });
      // form.setFieldsValue({ contact: value });
      form.setFieldsValue({ contact: util.toNumeric(value) });

      return;
    }

    let partner = { ...partnerSummary };
    partner.contact = value;
    setpartnerSummary(partner);
  };

  const onNameBlur = (e) => {
    const { value, name } = e.target;
    const textValue = util.toPascalText(value);
    form.setFieldsValue({ [name]: textValue });
    let partner = { ...partnerSummary };
    partner.name = textValue;
    setpartnerSummary(partner);
  };

  const handleModalSubmit = (values) => {
    let _address = { ...values, "country": values.country.value };

    if (isLocal) {
      _address = {
        ...values, "country": values.country.value, "province": values.province.value,
      };
    }
    setAddress(_address);
    setShowModal(false);
    setshowAddressInfo(true);
  };

  const handleGetRepresentatives = (representatives) => {
    const updatedRepr = representatives.map((item) => ({
      key: item.cellNumber,
      id: -1,
      uuid: "00000000-0000-0000-0000-000000000000",
      title: item.title,
      name: item.name,
      surname: item.surname,
      email: item.email,
      cellNumber: item.cellNumber,
      telephoneNumber: item.telephoneNumber,
    }));

    setRepresentatives(updatedRepr);
  };

  const onSubmit = async (partner) => {
    
    var msg;
    var action = "Adding Partner"

    try {

      const request = await api.addPartnership(partner, representatives, address);

      if (request.status == 200 || request.status == 201) {
        clearFormContents();
        msg = util.parseMessage(Messages.ADD_SUCCESS, "Partner");
        openNotification(action, msg, Notify.SUCCESS);
        return;
      }

      msg = util.parseMessage(Messages.ADD_FAILURE, "Partner");
      openNotification(action, msg, Notify.ERROR);

    } catch (error) {

      if (error.response.status == 409) {
        msg = util.parseMessage(Messages.EXIST_ADD_FAILURE, "Partner");
        openNotification(action, msg, Notify.ERROR);
        recordError(error);
        
        return;
      }

      msg = util.parseMessage(Messages.ADD_FAILURE, "Partner");
  
      openNotification(action, msg, Notify.ERROR);
    }
  };

  const clearFormContents = () => {
    form.resetFields();
    setSelectedOption("");
    setAddress({});
    setpartnerSummary({});
    setShowModal(false);
    setshowAddressInfo(false);
    setShowOther(false);
    setRepresentatives([]);
  }

  const onContributeSelection = () => {

    const otherContribution = contributions.find((record) => record.value === contribEnum.OTHER);

    const selectedValues = form.getFieldValue("contributions");

    if (selectedValues.includes(otherContribution.key.toString())) {
      setShowOther(true);
    } else {
      setShowOther(false);
    }
  };

  return (
    <>
      <div className="content">
        {/* <PageHeader
          title="New Partner"
          subTitle="Add partner, add address and more"
          extra={[
            <Link key="1" to="/partnership">
              <Button type="default">Back</Button>
            </Link>,
            <Button key="2" htmlType="submit" form={formName} type="primary">
              Save
            </Button>,
          ]}
        ></PageHeader> */}
        <Row>
          <Col xs={24} md={24} >
            <h1 className="center-align">Add New Partner</h1>
            <br />
          </Col>
        </Row>
        {/* <Divider /> */}
        <Alert
          message="Things to note: "
          description={
            <>
              <b>1. More than one contribution can be added.</b> <br />
              <b>2. More than one representative can be added.</b>
            </>
          }
          type="info"
          showIcon
        />
                <br />
        <Row>
          <Col xs={24}>
            <div className="main">
              <Row>
                <Col xs={24} md={10} >
                  <div className="form-container">
                    <Form
                      {...formItemLayout}
                      name={formName}
                      form={form}
                      layout="horizontal"
                      onFinish={onSubmit}
                    >
                      <Form.Item
                        name="name"
                        label="Name"
                        rules={[
                          { required: true, message: "Please enter partner name" },
                        ]}
                      >
                        <Input name="name" onBlur={onNameBlur} />
                      </Form.Item>
                      <Form.Item
                        name="partnerType"
                        label="Partner Type"
                        rules={[
                          { required: true, message: "Please select partner type" },
                        ]}
                      >
                        <Select onChange={onChange}>
                          {types.map((type) => (
                            <Option key={type.value}>{type.text}</Option>
                          ))}
                        </Select>
                      </Form.Item>
                      <Form.Item
                        name="initiationDate"
                        label="Initiation Date"
                        rules={[
                          { required: true, message: "Please select initiation date" },
                        ]}
                      >
                        <DatePicker onChange={onInitiationChange} picker="month" disabledDate={disabledDates} />
                      </Form.Item>
                      <Form.Item
                        name="contact"
                        label="Contact"
                        rules={[
                          { required: true, message: "Please enter partner contact" }
                        ]}
                      >
                        <ContactField onContactChange={handleContactChange} contactValue={defaultContact}/>
                      </Form.Item>
                      <Form.Item
                        name="email"
                        label="Email"
                        rules={[
                          {
                            required: true,
                            type: "email",
                            message: "Please enter partner Email",
                          },
                        ]}
                      >
                        <Input />
                      </Form.Item>

                      <Form.Item
                        name="address"
                        label="Address Option"
                        rules={[
                          {
                            required: true,
                            message: "Please select partner address option",
                          },
                        ]}
                      >
                        <Radio.Group onChange={onChangeLocality} value={selectedOption}>
                          {localityOptions.map((option) => (
                            <Radio key={option.key} value={option.key}>
                              {option.value}
                            </Radio>
                          ))}
                        </Radio.Group>
                      </Form.Item>
                      <div >
                        {showAddressInfo && (
                          <Card
                            style={{
                              width: "100%",
                              marginTop: 16,
                              justifyContent: "center",
                              marginBottom: 10,
                              backgroundColor: "rgb(250 250 250)",
                              borderBlockStyle: "solid",
                              borderColor: "#CCC",
                            }}
                            actions={[
                              <Button
                                key="Edit"
                                value="Edit"
                                type="default"
                                onClick={() => setShowModal(true)}
                              >
                                Edit
                              </Button>,
                            ]}
                          >
                            {isLocal ? (
                              <Meta
                                avatar={<Avatar icon={<GlobalOutlined />} />}
                                title={"Local Address"}
                                description={`${address.street} ${address.cityOrTown} ${address.province} ${address.postalCode}, ${address.country}`}
                              />
                            ) : (
                              <Meta
                                avatar={<Avatar icon={<GlobalOutlined />} />}
                                title={"Foreign Address"}
                                description={`${address.street} ${address.cityOrTown} ${address.province} ${address.postalCode}, ${address.country}`}
                              />
                            )}
                          </Card>
                        )}
                      </div>
                      <Form.Item
                        name="contributions"
                        label="Contributions"
                        rules={[
                          {
                            required: true,
                            message: "Please select at least 1 contribution type",
                          },
                        ]}
                      >
                        <Select
                          mode="multiple"
                          allowClear
                          style={{ width: "100%" }}
                          placeholder="Please select"
                          onSelect={onContributeSelection}
                          onChange={onContributeSelection}
                        >
                          {contributions.map((contribute) => (
                            <Option key={contribute.key}>{contribute.value}</Option>
                          ))}
                        </Select>
                      </Form.Item>

                      {showOther && (
                        <Form.Item
                          name="other"
                          label="Other"
                          rules={[
                            {
                              required: true,
                              message: "Please enter other contibutions",
                            },
                          ]}
                        >
                          <Input />
                        </Form.Item>
                      )}
                    </Form>
                  </div>
                </Col>
                <Col md={2}></Col>
                <Col xs={24} md={12} >
                  <div style={{ marginBottom: 20 }}>
                    <RepresentativeList
                      key="1"
                      isAdd={true}
                      partnerSummary={partnerSummary}
                      onGetAll={handleGetRepresentatives}
                      repList={representatives}
                    />
                    <AddressControl
                      key="2"
                      onCancel={handleCancel}
                      visible={showModal}
                      title="Add Address"
                      isLocal={isLocal}
                      onModalSubmit={handleModalSubmit}
                      address={address}
                    />
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={24} className="right-align">
            <Link key="1" to="/partnership">
              <Button type="default" style={{ marginRight: 10 }}>Back</Button>
            </Link>
            <Button key="2" htmlType="submit" form={formName} type="primary">
              Save
            </Button>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default CreatePartner;
